import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'gatsby'

import styles from './button.module.scss'
import ArrowIconSVG from './images/arrow.inline.svg'

const Button = props => {
  const { link, href, target, children, Tag, type, className } = props
  const classes = classNames(styles.el, className)

  const content = (
    <span className={styles.el__inner}>
      <span className={styles.el__icon}>
        <ArrowIconSVG />
      </span>
      <span className={styles.el__text}>{children}</span>
    </span>
  )
  if (link) {
    return (
      <Link className={classes} to={link.url}>
        {content}
      </Link>
    )
  }
  return (
    <Tag href={href} className={classes} type={type} target={target}>
      {content}
    </Tag>
  )
}

Button.defaultProps = {
  link: null,
  href: '',
  target: '',
  Tag: 'a',
  type: '', // for <button type="" />
  className: '',
}

Button.propTypes = {
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    link_type: PropTypes.string.isRequired,
    target: PropTypes.string,
  }),
  href: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
  Tag: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
}

export default Button
